// API endpoints для админ панели
// Эти endpoints будут реализованы в backend позже

export const API_ENDPOINTS = {
  // Авторизация админа
  auth: {
    login: '/admin/auth/login',
    me: '/admin/auth/me',
    logout: '/admin/auth/logout',
  },
  
  // Управление пользователями
  users: {
    list: '/admin/users',
    create: '/admin/users',
    details: (id: number) => `/admin/users/${id}`,
    update: (id: number) => `/admin/users/${id}`,
    updateStatus: (id: number) => `/admin/users/${id}/status`,
    updateRole: (id: number) => `/admin/users/${id}/role`,
  },

  // Роли админки (F2)
  roles: {
    list: '/admin/roles',
    catalog: '/admin/roles/catalog',
    create: '/admin/roles',
    update: (id: number) => `/admin/roles/${id}`,
    delete: (id: number) => `/admin/roles/${id}`,
    assign: (userId: number) => `/admin/users/${userId}/admin-role`,
  },
  
  // Управление курьерами на модерации
  couriers: {
    pending: '/admin/couriers/pending',
    approve: (id: number) => `/admin/couriers/${id}/approve`,
    reject: (id: number) => `/admin/couriers/${id}/reject`,
    reopen: (id: number) => `/admin/couriers/${id}/reopen`,
    moderationHistory: (id: number) => `/admin/couriers/${id}/moderation-history`,
  },
  
  // Справочники
  dictionaries: {
    regions: {
      list: '/admin/dictionaries/regions',
      create: '/admin/dictionaries/regions',
      update: (id: number) => `/admin/dictionaries/regions/${id}`,
      delete: (id: number) => `/admin/dictionaries/regions/${id}`,
    },
  },

  // Новые справочники (отдельные эндпоинты)
  activityTypes: {
    list: '/admin/activity-types',
    create: '/admin/activity-types',
    update: (id: number) => `/admin/activity-types/${id}`,
    delete: (id: number) => `/admin/activity-types/${id}`,
  },
  
  transportTypes: {
    list: '/admin/transport-types',
    create: '/admin/transport-types',
    update: (id: number) => `/admin/transport-types/${id}`,
    delete: (id: number) => `/admin/transport-types/${id}`,
  },

  // FAQ (Частые вопросы)
  faq: {
    list: '/admin/faq',
    create: '/admin/faq',
    update: (id: number) => `/admin/faq/${id}`,
    delete: (id: number) => `/admin/faq/${id}`,
  },

  // Юридические лица
  legalEntities: {
    list: '/admin/legal-entities',
    details: (id: number) => `/admin/legal-entities/${id}`,
    approve: (id: number) => `/admin/legal-entities/${id}/approve`,
    reject: (id: number) => `/admin/legal-entities/${id}/reject`,
    disable: (id: number) => `/admin/legal-entities/${id}/disable`,
    enable: (id: number) => `/admin/legal-entities/${id}/enable`,
  },

  // Логи API запросов (право audit.view)
  logs: {
    list: '/admin/logs/list',
    current: '/admin/logs/current',
    download: (filename: string) => `/admin/logs/download/${filename}`,
    preview: (filename: string) => `/admin/logs/preview/${filename}`,
  },

  // Тарифы курьеров
  tariffs: {
    list: '/admin/tariffs',
    create: '/admin/tariffs',
    details: (id: number) => `/admin/tariffs/${id}`,
    update: (id: number) => `/admin/tariffs/${id}`,
    remove: (id: number) => `/admin/tariffs/${id}`,
    duplicate: (id: number) => `/admin/tariffs/${id}/duplicate`,
    setCourier: (id: number) => `/admin/tariffs/${id}/courier`,
    createVersion: (id: number) => `/admin/tariffs/${id}/versions`,
    updateVersion: (id: number, versionId: number) =>
      `/admin/tariffs/${id}/versions/${versionId}`,
    publishVersion: (id: number, versionId: number) =>
      `/admin/tariffs/${id}/versions/${versionId}/publish`,
    activate: (id: number) => `/admin/tariffs/${id}/activate`,
    deactivate: (id: number) => `/admin/tariffs/${id}/deactivate`,
    preview: '/admin/tariffs/preview',
    courierSummary: (courierId: number) =>
      `/admin/tariffs/couriers/${courierId}/summary`,
  },
  courierLedger: {
    list: '/admin/courier-ledger',
    details: (id: number) => `/admin/courier-ledger/${id}`,
    recalculate: (id: number) => `/admin/courier-ledger/${id}/recalculate`,
    problemOrders: '/admin/courier-ledger/problem-orders',
    exportCsv: '/admin/courier-ledger/export.csv',
  },

  // Заказы (read-only раздел логиста)
  orders: {
    list: '/admin/orders',
    details: (id: number) => `/admin/orders/${id}`,
    history: (id: number) => `/admin/orders/${id}/history`,
    filters: '/admin/orders/filters',
    couriers: '/admin/orders/couriers',
    courierLoad: (id: number, date: number) =>
      `/admin/orders/couriers/${id}/load?date=${date}`,
  },

  // Тарифы юрлиц (конструктор)
  clientTariffs: {
    list: '/admin/client-tariffs',
    create: '/admin/client-tariffs',
    details: (id: number) => `/admin/client-tariffs/${id}`,
    update: (id: number) => `/admin/client-tariffs/${id}`,
    activate: (id: number) => `/admin/client-tariffs/${id}/activate`,
    pause: (id: number) => `/admin/client-tariffs/${id}/pause`,
    remove: (id: number) => `/admin/client-tariffs/${id}`,
    preview: '/admin/client-tariffs/preview',
  },

  // Версии мобильного приложения (кампании обновления)
  appVersions: {
    list: '/admin/app-versions',
    update: (platform: string) => `/admin/app-versions/${platform}`,
    toggle: (platform: string) => `/admin/app-versions/${platform}/toggle`,
    history: '/admin/app-versions/history',
  },

  // Пуш-рассылки (аудитория, отправка, история)
  push: {
    audience: '/admin/push/audience',
    campaigns: '/admin/push/campaigns',
    history: '/admin/push/history',
    resend: (id: number) => `/admin/push/campaigns/${id}/resend`,
  },

  // Демо-баланс юрлиц: счета, журнал операций, резервы
  balance: {
    entityBalance: (id: number) => `/admin/legal-entities/${id}/balance`,
    entityOperations: (id: number) => `/admin/legal-entities/${id}/operations`,
    entityInvoices: (id: number) => `/admin/legal-entities/${id}/invoices`,
    entityHolds: (id: number) => `/admin/legal-entities/${id}/holds`,
    createInvoice: (id: number) => `/admin/legal-entities/${id}/invoices`,
    releaseHold: (id: number, entryId: number) =>
      `/admin/legal-entities/${id}/holds/${entryId}/release`,
    settings: (id: number) => `/admin/legal-entities/${id}/balance-settings`,
    invoices: '/admin/invoices',
    confirm: (id: number) => `/admin/invoices/${id}/confirm`,
    cancel: (id: number) => `/admin/invoices/${id}/cancel`,
    pdf: (id: number) => `/admin/invoices/${id}/pdf`,
  },
} as const